/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Flex, Text, View } from "@aws-amplify/ui-react";
export default function CommonBtnText(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: { text: {}, "Rectangle 32": {}, CommonBtnText: {} },
      variantValues: { type: "Select", size: "Small" },
    },
    {
      overrides: {
        text: { fontSize: "20px", lineHeight: "32px", letterSpacing: "0.85px" },
        "Rectangle 32": {},
        CommonBtnText: {},
      },
      variantValues: { type: "Select", size: "Large" },
    },
    {
      overrides: {
        text: { color: "rgba(53,56,59,1)" },
        "Rectangle 32": { display: "none" },
        CommonBtnText: {},
      },
      variantValues: { type: "Default", size: "Small" },
    },
    {
      overrides: {
        text: {
          fontSize: "20px",
          color: "rgba(53,56,59,1)",
          lineHeight: "32px",
          letterSpacing: "0.85px",
        },
        "Rectangle 32": { display: "none" },
        CommonBtnText: {},
      },
      variantValues: { type: "Default", size: "Large" },
    },
    {
      overrides: {
        text: { color: "rgba(170,170,170,1)" },
        "Rectangle 32": { display: "none" },
        CommonBtnText: {},
      },
      variantValues: { type: "Hover", size: "Small" },
    },
    {
      overrides: {
        text: {
          fontSize: "20px",
          color: "rgba(170,170,170,1)",
          lineHeight: "32px",
          letterSpacing: "0.85px",
        },
        "Rectangle 32": { display: "none" },
        CommonBtnText: {},
      },
      variantValues: { type: "Hover", size: "Large" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Flex
      gap="0"
      direction="column"
      width="unset"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="0px 0px 0px 0px"
      display="flex"
      {...rest}
      {...getOverrideProps(overrides, "CommonBtnText")}
    >
      <Text
        fontFamily="Noto Sans"
        fontSize="16px"
        fontWeight="400"
        color="rgba(0,153,255,1)"
        lineHeight="25.600000381469727px"
        textAlign="center"
        display="block"
        direction="column"
        justifyContent="unset"
        letterSpacing="0.65px"
        width="unset"
        height="unset"
        gap="unset"
        alignItems="unset"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="発生中"
        {...getOverrideProps(overrides, "text")}
      ></Text>
      <View
        width="unset"
        height="1px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        backgroundColor="rgba(0,153,255,1)"
        {...getOverrideProps(overrides, "Rectangle 32")}
      ></View>
    </Flex>
  );
}
